import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="cookie-policy-page">
      {/* Header */}
      <section className="py-12 md:py-16 bg-[#2E5C31]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-white">
          <Link to="/" className="inline-flex items-center text-white/80 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold font-['Poppins']">Cookie Policy</h1>
          <p className="text-gray-200 mt-2">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="policy-content prose prose-lg">
            <h2>What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners.
            </p>

            <h2>How We Use Cookies</h2>
            <p>
              DecorVista Landscaping Services uses cookies to enhance your browsing experience and improve our website. We use cookies for the following purposes:
            </p>

            <h3>Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.
            </p>

            <h3>Analytics Cookies</h3>
            <p>
              We use analytics cookies to understand how visitors interact with our website. This helps us improve our website and services. These cookies collect information anonymously.
            </p>

            <h3>Functionality Cookies</h3>
            <p>
              These cookies allow the website to remember choices you make (such as your preferred language or region) and provide enhanced, more personalized features.
            </p>

            <h3>Marketing Cookies</h3>
            <p>
              These cookies are used to track visitors across websites to display ads that are relevant and engaging for the individual user. These cookies may be set through our site by our advertising partners.
            </p>

            <h2>Types of Cookies We Use</h2>
            <table className="w-full border-collapse border border-gray-300 my-6">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-3 text-left">Cookie Type</th>
                  <th className="border border-gray-300 p-3 text-left">Purpose</th>
                  <th className="border border-gray-300 p-3 text-left">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-3">Session Cookies</td>
                  <td className="border border-gray-300 p-3">Enable website functionality</td>
                  <td className="border border-gray-300 p-3">Session</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-3">Preference Cookies</td>
                  <td className="border border-gray-300 p-3">Remember your settings</td>
                  <td className="border border-gray-300 p-3">1 year</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-3">Analytics Cookies</td>
                  <td className="border border-gray-300 p-3">Track website usage</td>
                  <td className="border border-gray-300 p-3">2 years</td>
                </tr>
              </tbody>
            </table>

            <h2>Third-Party Cookies</h2>
            <p>
              Some cookies may be placed by third-party services that appear on our pages. We do not control these cookies. Third parties that may set cookies include:
            </p>
            <ul>
              <li>Google Analytics (for website analytics)</li>
              <li>Google Ads (for advertising)</li>
              <li>Social media platforms (if you use share buttons)</li>
            </ul>

            <h2>Managing Cookies</h2>
            <p>
              Most web browsers allow you to control cookies through their settings. You can:
            </p>
            <ul>
              <li>View what cookies are stored on your device</li>
              <li>Delete all or selected cookies</li>
              <li>Block all or selected cookies</li>
              <li>Set preferences for certain websites</li>
            </ul>
            <p>
              Please note that blocking cookies may impact your experience on our website and limit certain functionality.
            </p>

            <h3>How to Manage Cookies in Popular Browsers</h3>
            <ul>
              <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies</li>
              <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies</li>
              <li><strong>Edge:</strong> Settings → Cookies and Site Permissions</li>
            </ul>

            <h2>Do Not Track</h2>
            <p>
              Some browsers have a "Do Not Track" feature that signals websites you visit that you do not want to have your online activity tracked. Our website currently does not respond to "Do Not Track" signals.
            </p>

            <h2>Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our data practices. Any changes will be posted on this page with an updated revision date.
            </p>

            <h2>Contact Us</h2>
            <p>If you have questions about our use of cookies, please contact us:</p>
            <ul>
              <li><strong>Business Name:</strong> DecorVista Landscaping Services</li>
              <li><strong>Address:</strong> 667 Harbor View Drive, Seattle, WA 98101</li>
              <li><strong>Phone:</strong> +1-888-880-8889</li>
              <li><strong>Email:</strong> support@decorvista.store</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
